class Messages {
    deleteMessage(id) {
        app.ajax.delete('/services/user/messages/' + id, [], this._messageDeleted);
    }

    _messageDeleted(response) {
        jQuery('.message[data-id="' + response.id + '"]').remove();
    }

    getMessageModal(username, templateCategory) {
        if (typeof username == "string") {
            app.ajax.get('/services/user/messages/send-message-modal', {
                username: username,
                templateCategory: templateCategory
            }, this._showModal.bind(this));
        } else {
            app.ajax.get('/services/user/messages/send-message-modal', {}, this._showModal.bind(this));
        }
    }

    getReplyModal(messageId) {
        app.ajax.get('/services/user/messages/reply-message-modal', {id: messageId}, this._showModal.bind(this));
    }

    getForwardModal(messageId) {
        app.ajax.get('/services/user/messages/forward-message-modal', {id: messageId}, this._showModal.bind(this));
    }

    _showModal(response) {
        app.modal.open("", response.body, "", null, () => {
            this.templates = document.getElementById("templates");
            if (this.templates) {
                this.templates.addEventListener("change", function (e) {
                    if (e.currentTarget.selectedOptions[0].value) {
                        app.ajax.get("/services/user/messages/template/" + e.currentTarget.selectedOptions[0].value, null, function (data) {
                            if (data.status) {
                                document.getElementById("subject").value = data.template.subject;
                                $(".wysiwyg").last().trumbowyg("html", data.template.body);
                            }
                        });
                    } else {
                        document.getElementById("subject").value = "";
                        $(".wysiwyg").last().trumbowyg("empty");
                    }
                });
            }
        }, null, () => {
            $(".wysiwyg").last().trumbowyg('destroy');
        });
    }

    show(id) {
        jQuery(".message[data-id='" + id + "']").removeClass("unread");
        app.ajax.get('/services/user/messages/' + id, {}, this._showMessageModal.bind(this));
    }

    _showMessageModal(response) {
        app.modal.open('', response.body, '');
    }
}